import React from 'react';
import '../../styles/componentStyles/cursor.scss'

// export const CustomCursor = () => {

//   return(
//     <div className="app-cursor"></div>
//   );
// }


function CustomCursor(props) {
  const cursorRef = React.useRef(null);

  React.useEffect(() => {
    document.addEventListener('mousemove', (event) => {
      const {clientX, clientY} = event;
      const mouseX = clientX ;
      const mouseY = clientY ;
      // console.log(`${cursorRef.current.clientHeight}, ${cursorRef.current.clientWidth}`)
      // console.log(`${mouseX}, ${mouseY}`)
    cursorRef.current.style.transform = `translate3d( ${mouseX}px, ${mouseY}px, 0)`;
    // cursorRef.current.style.transform = `translateX( ${mouseX}px )`;
    // cursorRef.current.style.transform = `translateY( ${mouseY}px )`;

    })
  }, [])
  

    

    return  <div className="app-cursor" ref={cursorRef}></div>
       
    
  
}

export default CustomCursor;